import {
  CreateSpaceDialogContent,
  type CreateSpaceDialogProps,
} from '@github-ui/copilot-spaces/components/CreateSpaceDialog'
import {getAutoSpaceName, useFetchCopilotSpaces} from '@github-ui/copilot-spaces/hooks'
import {useUpsertCopilotSpace} from '@github-ui/copilot-spaces/hooks/use-upsert-copilot-space-no-chat-state'

export function AgentsCreateSpaceDialog(props: CreateSpaceDialogProps) {
  const {data: spaces = [], isPending: isLoadingSpaces} = useFetchCopilotSpaces(true)
  const defaultName = getAutoSpaceName(spaces.length)
  const {upsertCopilotSpace, isPending} = useUpsertCopilotSpace()

  if (isLoadingSpaces) return null

  return (
    <CreateSpaceDialogContent
      {...props}
      defaultName={defaultName}
      upsertCopilotSpace={upsertCopilotSpace}
      isSaving={isPending}
    />
  )
}
